import { create } from 'zustand'

interface AppState {
  isLoading: boolean
  currentSection: string
  mousePosition: { x: number; y: number }
  performance: { fps: number; quality: 'high' | 'medium' | 'low' }
  
  setLoading: (loading: boolean) => void
  setCurrentSection: (section: string) => void
  setMousePosition: (position: { x: number; y: number }) => void
  setPerformance: (performance: { fps: number; quality: 'high' | 'medium' | 'low' }) => void
}

export const useAppStore = create<AppState>((set) => ({
  isLoading: true,
  currentSection: 'home',
  mousePosition: { x: 0, y: 0 },
  performance: { fps: 60, quality: 'high' },
  
  setLoading: (loading) => set({ isLoading: loading }),
  setCurrentSection: (section) => set({ currentSection: section }),
  setMousePosition: (position) => set({ mousePosition: position }),
  setPerformance: (performance) => set({ performance }),
}))
